function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  appearance: none;\n  background: none;\n  background-color: #fcfdfe;\n  border-radius: 2px;\n  box-shadow: none;\n  color: #707478;\n  font-size: 13px;\n  border: 1px solid #d1d5da;\n  padding: 14px 21px 13px;\n  margin: 5px auto;\n  ",
        "\n  width: 100%;\n  ",
        "\n  box-sizing: border-box;\n  outline: 0;\n  &:active,\n  &:focus {\n    border: 1px solid #7fb1f4;\n  }\n  &:hover {\n    @media ",
        " {\n      border: 1px solid #7fb1f4;\n      outline: none;\n    }\n  }\n  &::placeholder {\n    color: #aeafaf;\n  }\n  &[disabled] {\n    background-color: #ecf0f3;\n  }\n  ",
        "\n  ",
        "\n  @media ",
        " {\n    font-size: 16px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
import styled, { css } from 'styled-components';
import { width, space } from 'styled-system';
import { mediaQueries } from 'shared/styles';
export var textInputStyles = css(_templateObject(), space, width, mediaQueries.desktop, function(props) {
    return props.type === 'number' && "\n    -moz-appearance: textfield;\n    ::-webkit-outer-spin-button,\n    ::-webkit-inner-spin-button {\n      -webkit-appearance: none;\n    }\n  ";
}, function(props) {
    return props.disabled && "\n    background-color: whitesmoke;\n    border-color: whitesmoke;\n    box-shadow: none;\n    color: #7a7a7a;\n    cursor: not-allowed;\n  ";
}, mediaQueries.largePhone);
export default styled.input(_templateObject1(), textInputStyles);
